var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGourmet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49987 15.5H17.4999M9.99987 12.5V15.5M17.4999 14V17M6.49987 14V17M6.49987 12.0625C5.93348 11.9495 5.3955 11.724 4.91776 11.3994C4.44002 11.0749 4.03221 10.6578 3.71845 10.1729C3.40469 9.68799 3.19134 9.1451 3.09104 8.57631C2.99073 8.00752 3.0055 7.4244 3.13447 6.86142C3.26343 6.29844 3.50398 5.76704 3.84188 5.29864C4.17979 4.83023 4.60818 4.43435 5.10174 4.13438C5.5953 3.83442 6.144 3.63647 6.71539 3.55224C7.28677 3.46801 7.86925 3.49921 8.42837 3.644C8.83236 3.13113 9.34752 2.71667 9.93502 2.43189C10.5225 2.14711 11.167 1.99943 11.8199 2C12.4915 1.99942 13.1541 2.1557 13.7547 2.45639C14.3553 2.75709 14.8774 3.19389 15.2794 3.732C15.8395 3.54198 16.4327 3.46901 17.0222 3.51763C17.6118 3.56624 18.185 3.7354 18.7065 4.01462C19.2279 4.29385 19.6865 4.67718 20.0537 5.14088C20.421 5.60457 20.6891 6.13875 20.8414 6.7103C20.9938 7.28185 21.0271 7.8786 20.9394 8.46357C20.8517 9.04854 20.6448 9.60927 20.3315 10.111C20.0183 10.6127 19.6053 11.0448 19.1182 11.3804C18.6311 11.716 18.0803 11.948 17.4999 12.062V20C17.4999 20.2652 17.3945 20.5196 17.207 20.7071C17.0194 20.8946 16.7651 21 16.4999 21H7.49987C7.23465 21 6.9803 20.8946 6.79276 20.7071C6.60523 20.5196 6.49987 20.2652 6.49987 20V12.0625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGourmet);
export default __webpack_public_path__ + "static/media/icon-gourmet.4d86c2b7.svg";
export { ForwardRef as ReactComponent };